import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import GroupsIcon from "@mui/icons-material/Groups";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MemoryIcon from "@mui/icons-material/Memory";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import WindowIcon from "@mui/icons-material/Window";
import { Divider, Stack } from "@mui/material";
import MenuGroup from "./menu/MenuGroup";
import MenuItem from "./menu/MenuItem";

function WorkspaceSidebar() {
    return (
        <Stack widht="100%" heigth="100%">
            <MenuGroup text="Monitor">
                <MenuItem to="/dashboard-hub/search" text="Dashboard Hub" icon={<LeaderboardIcon />} />
                {/**
                <MenuItem to="/groups" text="Groups/Teams" icon={<GroupsIcon />} disabled={true} />
                */}
            </MenuGroup>
            <Divider />
            <MenuGroup text="Workspace">
                <MenuItem
                    to="/workspace/data-collections"
                    text="Data Collections"
                    icon={<FolderZipIcon />}
                    disabled={true}
                />
                {/**
                <MenuItem to="/workspace/swots" text="SWOTs" icon={<WindowIcon />} disabled={true} />
                <MenuItem to="/workspace/work-systems" text="Work Systems" icon={<MemoryIcon />} disabled={true} />
                */}
                <MenuItem to="/workspace/strategic-plannings" text="Strategic Planning" icon={<AccountTreeIcon />} />
                <MenuItem to="/workspace/projects" text="Projects" icon={<AssignmentIcon />} disabled={true} />
                <MenuItem
                    to="/workspace/risk-managements"
                    text="Risk Managements"
                    icon={<CrisisAlertIcon />}
                    disabled={true}
                />
                <MenuItem to="/workspace/kpis" text="KPIs" icon={<QueryStatsIcon />} />
            </MenuGroup>
            <MenuGroup text="Personal's settings">
                <MenuItem
                    to={"/users/settings"}
                    text="Account Settings"
                    icon={<ManageAccountsIcon />}
                    disabled={true}
                />
            </MenuGroup>
        </Stack>
    );
}

export default WorkspaceSidebar;
